module.exports = __webpack_public_path__ + "img/ft2.7d58ce50.jpg";